// extracted by mini-css-extract-plugin
module.exports = {"Dots":"styles_Dots__wDSnh","Dot":"styles_Dot__3BbQJ"};